var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2h12v4h-2V4H8v2H6zM8 20v-2H6v4h12v-4h-2v2zM2 10a3 3 0 0 1 3.001-3h13.998A3 3 0 0 1 22 10v5a3 3 0 0 1-3 3v-2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1.001-1H5.001A1 1 0 0 0 4 10v5a1 1 0 0 0 1 1v2a3 3 0 0 1-3-3zm4 2h12v6h-2v-4H8v4H6z"
  }))));
};
export { SvgPrinter as Icon };
export default __webpack_public_path__ + "static/media/26a4d5c6c313add841d7899c76aa3407.svg";